import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { HookSection } from '../components/HookSection';
import { RevealSection } from '../components/RevealSection';
import { BenefitsSection } from '../components/BenefitsSection';
import { ContentsSection } from '../components/ContentsSection';
import { AudienceSection } from '../components/AudienceSection';
import { PricingSection } from '../components/PricingSection';
import { FAQSection } from '../components/FAQSection';
import { Footer } from '../components/Footer';
export function SalesPage() {
  return <main className="w-full min-h-screen" data-id="element-180">
      <HeroSection data-id="element-181" />
      <HookSection data-id="element-182" />
      <RevealSection data-id="element-183" />
      <BenefitsSection data-id="element-184" />
      <ContentsSection data-id="element-185" />
      <AudienceSection data-id="element-186" />
      <PricingSection data-id="element-187" />
      <FAQSection data-id="element-188" />
      <Footer data-id="element-189" />
    </main>;
}